<template>
 <!--Ionic Slider-->
 <ion-grid class="spacer">
 
    <ion-row>
        <ion-col sizeXs="12" sizeMd="12" sizeLg="12">
            <ion-text color="primary">
                <h2 class="ion-margin-start" ><b>Your Playlists</b></h2>
                

            </ion-text>

    <ion-row>
        <ion-col sizeXs="6" sizeMd="4" sizeLg="2"  v-for="todo in communityPlaylist" :key="todo.playlistId">
                           <ion-card @click="redirect(todo.playlistId)">
                        
                        <div v-for="n in getPlaylistDetails(todo)" :key="n.spotifyId">
                            <div v-for="(z,index) in n" :key="z.spotifyId">

                                <img v-if="index === 0" :src="z.imgUrl" class="card-img">

                            </div>   
                        </div> 

                        <ion-card-title class="ion-margin-top ion-margin-bottom ion-margin-start">{{todo.playlistName}}</ion-card-title>

                        <ion-card-content>
                            <p style="margin-left: 12px;"> {{todo.userId}} </p>
                        </ion-card-content>
                    </ion-card>
        </ion-col>

    
      </ion-row>

    

          

            
        </ion-col>


    </ion-row>
 </ion-grid>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import axios from 'axios';
import { useRouter } from 'vue-router';

export default defineComponent({
  data() {
    return {
      communityPlaylist: [],
      chartsPlaylist: []
    }
  },

 setup() {
    // const revents = [{
    //     'event_name': 'Lewis Concert'
    // }]

    const router = useRouter();
 
    // Optional parameters to pass to the swiper instance. See http://idangero.us/swiper/api/ for valid options.
    const slideOpts = {
      slidesPerView: 3,
      spaceBetween: 10,
      initialSlide: 0,
      speed: 100,
      breakpoints: {
        // when window width is >= 320px
        320: {
        slidesPerView: 2,
        spaceBetween: 0
        },
        // when window width is >= 480px
        768: {
        slidesPerView: 3,
        spaceBetween: 30
        },
        // when window width is >= 640px
        1024: {
        slidesPerView: 5,
        spaceBetween: 0
        }
    }
    };

    return { slideOpts, router }
  },
  methods: {
    redirect(id: string){
      console.log("CLICKED");
        this.router.push('/music/playlist/p/' + id);
    },
    getPlaylistDetails(items: Record<string, any>){
        //const carditems = items.songs
        //console.log("hello")
        //console.log(carditems)
        const carditems = items.songs
        return {carditems}
    },
    getChartsDetails(items: Record<string, any>){
        //const carditems = items.songs
        //console.log("hello")
        //console.log(carditems)
        const carditems = items.songs
        return {carditems}
    }
  },
  mounted() {   
    axios.get('https://us-central1-nightingale-1d29b.cloudfunctions.net/getUserPlaylist?userId=' + localStorage.getItem("userID"))
      .then(
          res => this.communityPlaylist = res.data)
          


           window.addEventListener('playlist-deleted', event => {
      
                   axios.get('https://us-central1-nightingale-1d29b.cloudfunctions.net/getUserPlaylist?userId=' + localStorage.getItem("userID"))
      .then(
          res => this.communityPlaylist = res.data)
           
          }, false);
  } 
});
</script>


<style scoped>
.card-img{
        padding:0;
    }
ion-card-title{
    color:#fefefe;
    text-align:left;
    font-size:15px;
    margin-top: 7px;
    margin-left: 5px;
    font-weight:bold;

}
ion-card-content{
    text-align:left;
    font-size:12.5px;
    margin-top: -25px;
    margin-left: -25px;
}

.spacer{
    margin-left: 5px;
    margin-right: 5px;
}

.card-text-adj{
    margin-left:-20px;
}

</style>

